import { useState, useCallback } from 'react';

export interface GlobalHeaderState {
  waffleOpen: boolean;
  userMenuOpen: boolean;
  toggleWaffle: () => void;
  toggleUserMenu: () => void;
  closeAll: () => void;
}

export function useGlobalHeaderState(): GlobalHeaderState {
  const [waffleOpen, setWaffleOpen] = useState(false);
  const [userMenuOpen, setUserMenuOpen] = useState(false);

  const toggleWaffle = useCallback(() => {
    setWaffleOpen(prev => !prev);
    setUserMenuOpen(false);
  }, []);

  const toggleUserMenu = useCallback(() => {
    setUserMenuOpen(prev => !prev);
    setWaffleOpen(false);
  }, []);

  const closeAll = useCallback(() => {
    setWaffleOpen(false);
    setUserMenuOpen(false);
  }, []);

  return { waffleOpen, userMenuOpen, toggleWaffle, toggleUserMenu, closeAll };
}
